// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__OzC6s","bigColWidth":"Table_bigColWidth__3uQZF","biggerColWidth":"Table_biggerColWidth__k0_zm","row":"Table_row__1IaO3","col":"Table_col__Ig0SA"};